// extracted by mini-css-extract-plugin
module.exports = {"statPlayer":"style_statPlayer__AfhS_","playerImage":"style_playerImage__pxYST","icon":"style_icon__i8Ybq","serialNo":"style_serialNo__3NI32"};